import { queryOptions } from '@tanstack/react-query'

import { getPendingSignupFirstName } from '../contexts/auth-flow-storage'
import { queryKeys } from './query-keys'

export const pendingSignupFirstNameQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.authFlow.pendingSignupFirstName(),
    queryFn: getPendingSignupFirstName,
    staleTime: Infinity,
  })
